const FileTypes = {
  file: 'file',
  image: 'image',
};

export default FileTypes;
